module.exports = __webpack_public_path__ + "static/media/National Literacy - Forest Film1.6d17ffa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/National Literacy - Forest Film1.jpg
// module id = 175
// module chunks = 0